/* EAGLE CUSTOM – product page behaviour (Pillar only). Added 2026-10-11.
   0) Colour name in the title + description follows the selected colour (moved here from eagle-colour-sync so it
      also works inside the quick view, which is loaded after the page).
   1) Stock message follows the selected variant (snippets/eagle-stock.liquid).
   2) Description accordion is shown under the gallery on desktop, next to Pillar's other accordions
      (same pattern Pillar uses for its own "show below media" blocks). Mobile keeps it in the info column.
   3) Cart drawer + cart page: product names are swapped to the clean title (added 2026-10-13). Each name is
      fetched once from templates/product.eagle-title.liquid and cached for the visit.
   4) Variant picker: the "Color: …" label shows the clean colour name right after a click (added 2026-10-14;
      Pillar writes the raw Odoo value there until the section re-renders).
   5) Colour slider (mobile, more than 4 colours – eagle-pdp.css task 7): the selected colour is scrolled into
      view inside the row, without moving the page (added 2026-10-24).
   6) Size must be tapped by the shopper before add to cart / Buy it now (added 2026-10-24, see part 6).
   Listens to Pillar's 'variant:changed' event. Delete this file + the eagle_assets block to remove. */
(function () {
  if (window.EaglePDP) return;
  window.EaglePDP = true;

  /* ---------- 0) colour name ---------- */
  function updateColour(variantId) {
    if (!variantId) return;
    document.querySelectorAll('[data-eagle-colour-map]').forEach(function (mapEl) {
      var map; try { map = JSON.parse(mapEl.textContent); } catch (e) { return; }
      var name = map[String(variantId)];
      if (!name) return;
      var scope = mapEl.closest('quick-view-modal') || document;
      scope.querySelectorAll('[data-eagle-colour]').forEach(function (el) {
        if (scope === document && el.closest('quick-view-modal')) return;
        el.textContent = name;
      });
    });
  }

  /* ---------- 1) stock ---------- */
  function updateStock(variantId) {
    document.querySelectorAll('[data-eagle-stock]').forEach(function (box) {
      var mapEl = box.querySelector('[data-eagle-stock-map]');
      var msg = box.querySelector('.eagle-stock__msg');
      if (!mapEl || !msg || !variantId) return;
      var map; try { map = JSON.parse(mapEl.textContent); } catch (e) { return; }
      var row = map[String(variantId)]; if (!row) return;
      var qty = row[0], tracked = row[1] === 1, cont = row[2] === 1, limit = parseInt(box.dataset.limit, 10) || 15;
      var state = 'in', text = box.dataset.tIn;
      if (tracked) {
        if (qty > 0 && qty <= limit) { state = 'low'; text = box.dataset.tLow.replace('[n]', qty); }
        else if (qty <= 0 && !cont) { state = 'out'; text = box.dataset.tOut; }
      }
      msg.className = 'eagle-stock__msg eagle-stock--' + state;
      msg.textContent = text;
    });
  }

  /* ---------- 2) description under the gallery (desktop) ---------- */
  var mq = window.matchMedia('(min-width: 768px)');
  function placeDescription() {
    var slot = document.querySelector('.eagle-desc-slot');
    var below = document.querySelector('.product__blocks-below-media');
    var root = document.documentElement;
    if (!slot || !below) { root.classList.remove('eagle-desc-cloned'); return; }
    var html = slot.innerHTML;
    var clone = below.querySelector('[data-eagle-desc-clone]');
    if (!clone) {
      clone = document.createElement('div');
      clone.setAttribute('data-eagle-desc-clone', '');
      clone.className = 'product__block product__block--collapsible_tab';
      below.insertBefore(clone, below.firstChild);
    }
    if (clone.getAttribute('data-src') !== html) {   // refresh only when the content changed
      clone.innerHTML = html;
      clone.setAttribute('data-src', html);
    }
    root.classList.add('eagle-desc-cloned');
  }

  /* ---------- 3) clean titles in the cart ---------- */
  var titleCache = {};
  try { titleCache = JSON.parse(sessionStorage.getItem('eagleTitles') || '{}'); } catch (e) {}
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function cartTitles() {
    document.querySelectorAll('a.cart-item__title[href*="/products/"]').forEach(function (a) {
      var m = a.getAttribute('href').match(/\/products\/([^?#\/]+)/); if (!m) return;
      var key = root + m[1];
      var apply = function (t) {
        if (!t) return;
        if (a.textContent.trim() !== t) a.textContent = t;
        var item = a.closest('.cart-item, tr, li');
        if (item) item.querySelectorAll('h4').forEach(function (h) { if (h.textContent.trim() !== t) h.textContent = t; });
      };
      if (titleCache[key]) { apply(titleCache[key]); return; }
      if (titleCache[key] === '') return;
      titleCache[key] = '';
      fetch(root + 'products/' + m[1] + '?view=eagle-title', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (t) {
          t = (t || '').trim();
          if (t.length > 0 && t.length < 160 && t.indexOf('<') === -1) {
            var tmp = document.createElement('textarea'); tmp.innerHTML = t; t = tmp.value;
            titleCache[key] = t;
            try { sessionStorage.setItem('eagleTitles', JSON.stringify(titleCache)); } catch (e) {}
            cartTitles();
          }
        }).catch(function () {});
    });
  }

  /* ---------- 4) clean colour label right after a click ---------- */
  document.addEventListener('change', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var lab = t.getAttribute && t.getAttribute('data-eagle-label');
    if (!lab && t.tagName === 'SELECT' && t.selectedOptions && t.selectedOptions[0]) lab = t.selectedOptions[0].getAttribute('data-eagle-label');
    if (!lab) return;
    var box = t.closest('.product-form__input');
    var s = box && box.querySelector('[data-selected-swatch-value]');
    if (s) { s.textContent = lab; setTimeout(function () { s.textContent = lab; }, 0); }
  });

  /* ---------- 5) colour slider: keep the selected colour visible ---------- */
  function showSelectedSwatch() {
    document.querySelectorAll('.product-form__input--color').forEach(function (box) {
      if (box.scrollWidth <= box.clientWidth + 2) return;           // not a slider (4 colours or fewer / desktop)
      var input = box.querySelector('input[type="radio"]:checked');
      var label = input && box.querySelector('label[for="' + input.id + '"]');
      if (!label) return;
      var c = box.getBoundingClientRect(), l = label.getBoundingClientRect(), pad = 12;
      if (l.left < c.left) box.scrollBy({ left: l.left - c.left - pad });
      else if (l.right > c.right) box.scrollBy({ left: l.right - c.right + pad });
    });
  }

  /* ---------- 6) size must be chosen by the shopper (added 2026-10-24) ----------
     Pillar preselects the first available size, so "Add to cart" (main button, sticky bar, Buy it now) could
     add a size the shopper never picked -> COD refusals / cancellations. Until a size is tapped:
     the size buttons look unselected, both add buttons say "Choose size", and a tap scrolls to the sizes.
     Products with one size only (perfume, bags...) are not affected. Main product only (not quick view). */
  var isAr = (document.documentElement.lang || '').indexOf('ar') === 0;
  var T = isAr ? { choose: 'اختار المقاس', msg: 'اختار مقاسك الأول' } : { choose: 'Choose size', msg: 'Please choose your size first' };
  var sizeChosen = false;
  function mainInfo() { return document.querySelector('product-info[id^="MainProduct-"]'); }
  function sizeBox() {
    var info = mainInfo(); if (!info) return null;
    var boxes = info.querySelectorAll('variant-selects .product-form__input');
    for (var i = 0; i < boxes.length; i++) {
      var s = boxes[i].querySelector('[data-selected-swatch-value]');
      var n = ((s && s.getAttribute('data-selected-swatch-value')) || '').toLowerCase();
      if (n.indexOf('size') > -1 || n.indexOf('مقاس') > -1) return boxes[i];
    }
    return null;
  }
  function needsSize() {
    var box = sizeBox();
    return !!box && !sizeChosen && box.querySelectorAll('input[type="radio"]').length > 1;
  }
  function addButtons() {
    var info = mainInfo(); var list = [];
    if (info) list = [].slice.call(info.querySelectorAll('button[name="add"]'));
    document.querySelectorAll('sticky-atc-bar-minimalist button[name="add"], sticky-atc-bar button[name="add"]').forEach(function (b) { list.push(b); });
    return list;
  }
  function applySize() {
    var need = needsSize(), box = sizeBox();
    document.documentElement.classList.toggle('eagle-need-size', need);
    if (box) {
      box.classList.toggle('eagle-size-unset', need);
      var msg = box.querySelector('.eagle-size-msg');
      if (!need && msg) msg.remove();
    }
    addButtons().forEach(function (b) {
      var t = b.querySelector('.btn__text, span'); if (!t) return;
      var inSticky = !!b.closest('sticky-atc-bar-minimalist, sticky-atc-bar');
      if (need && !b.disabled) {
        if (t.textContent.trim() !== T.choose) t.textContent = T.choose;
      } else if (!need && t.textContent.trim() === T.choose && window.FoxTheme && FoxTheme.variantStrings) {
        t.textContent = inSticky ? (FoxTheme.variantStrings.addToCartShort || FoxTheme.variantStrings.addToCart) : FoxTheme.variantStrings.addToCart;
      }
    });
    stickySummary();
  }
  function stickySummary() {
    var bar = document.querySelector('sticky-atc-bar-minimalist, sticky-atc-bar'); var info = mainInfo();
    if (!bar || !info) return;
    var holder = bar.querySelector('.sticky-atc-bar__product-info'); if (!holder) return;
    var parts = [];
    info.querySelectorAll('variant-selects .product-form__input').forEach(function (box) {
      if (box === sizeBox() && needsSize()) return;
      var s = box.querySelector('[data-selected-swatch-value]'); var v = s && s.textContent.trim();
      if (v) parts.push(v);
    });
    var el = holder.querySelector('.eagle-sticky-variant');
    if (!el) { el = document.createElement('p'); el.className = 'eagle-sticky-variant'; var h = holder.querySelector('h3'); holder.insertBefore(el, h ? h.nextSibling : holder.firstChild); }
    var txt = parts.join(' · ');
    if (el.textContent !== txt) el.textContent = txt;
  }
  function promptSize() {
    var box = sizeBox(); if (!box) return;
    if (!box.querySelector('.eagle-size-msg')) {
      var m = document.createElement('p'); m.className = 'eagle-size-msg'; m.setAttribute('role', 'alert'); m.textContent = T.msg;
      var lg = box.querySelector('legend, label'); if (lg && lg.nextSibling) box.insertBefore(m, lg.nextSibling); else box.appendChild(m);
    }
    var top = box.getBoundingClientRect().top + window.pageYOffset - 140;
    window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    box.classList.remove('eagle-size-flash'); void box.offsetWidth; box.classList.add('eagle-size-flash');
  }
  function isMainAdd(t) {
    if (!t || !t.closest) return false;
    var b = t.closest('button[name="add"], .shopify-payment-button');
    if (!b) return false;
    if (b.closest('sticky-atc-bar-minimalist, sticky-atc-bar')) return true;
    var info = mainInfo(); return !!info && info.contains(b);
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    var box = sizeBox();
    if (box && t && t.closest && box.contains(t) && t.closest('input[type="radio"], label')) {   // shopper tapped a size (also the preselected one)
      sizeChosen = true; setTimeout(applySize, 0); setTimeout(applySize, 600); return;
    }
    if (isMainAdd(t) && needsSize()) { e.preventDefault(); e.stopImmediatePropagation(); promptSize(); }
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target, info = mainInfo();
    if (!needsSize() || !info || !f || !f.id || f.id.indexOf('product-form-') !== 0) return;
    if (info.contains(f) || f.id === 'product-form-' + (info.dataset.section || '')) { e.preventDefault(); e.stopImmediatePropagation(); promptSize(); }
  }, true);

  function run(variantId) {
    placeDescription();
    showSelectedSwatch();
    applySize();
    if (variantId) { updateStock(variantId); updateColour(variantId); }
  }

  document.addEventListener('variant:changed', function (e) {
    var v = e.detail && e.detail.variant;
    var id = v && v.id;
    run(id);
    setTimeout(function () { run(id); }, 600); // after Pillar re-renders the section
  });
  if (mq.addEventListener) mq.addEventListener('change', function () { placeDescription(); });

  function init() {
    run(null);
    cartTitles();
    if (window.MutationObserver) {
      var ct; new MutationObserver(function () { clearTimeout(ct); ct = setTimeout(cartTitles, 120); })
        .observe(document.body, { childList: true, subtree: true });
    }
    var cur = new URLSearchParams(location.search).get('variant');
    if (cur) updateStock(cur);
    var main = document.querySelector('.product');
    if (main && window.MutationObserver) {
      var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { placeDescription(); applySize(); }, 150); })
        .observe(main, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* EAGLE CUSTOM 2026-10-25: after a colour change, if the selected size doesn't exist for that colour (variant not
   created / switched off for Online Store), select the colour's first in-stock size so the photos follow the colour.
   The shopper still has to tap a size before Add to cart (part 6). */
(function () {
  function fix() {
    var info = document.querySelector('product-info[id^="MainProduct-"]'); if (!info) return;
    info.querySelectorAll('variant-selects .product-form__input--button').forEach(function (box) {
      var radios = box.querySelectorAll('input[type="radio"]');
      if (!radios.length || box.querySelector('input[type="radio"]:checked')) return;
      var pick = box.querySelector('input[type="radio"]:not(.disabled)') || radios[0];
      pick.checked = true;
      pick.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('product-info[id^="MainProduct-"] .product-form__input--color')) {
      setTimeout(fix, 700); setTimeout(fix, 1500);
    }
  });
  document.addEventListener('variant:changed', function () { setTimeout(fix, 700); });
})();